@if (promoBanners$ | async; as promoBanners) {
    @if (promoBanners.length > 0) {
        <div class="promo-banner-container">
            <ms-racing-promo-banner [banners]="promoBanners" />
        </div>
    }
}
<div class="greyhounds-container">
    <div class="greyhounds-left">
        <ms-meeting-switcher />
        @if (quickLink$ | async; as quickLink) {
            @if (quickLink.quickLinkItem.length) {
                <div class="link-list-widget link-list-grid">
                    <ms-top-bottom-sectionlinks
                        [showArrows]="false"
                        [items]="quickLink.quickLinkItem"
                        [tracking]="'quickLinks'"
                        [itemClass]="'col-12'"
                        [itemListClass]="'list row mb-0 shadow-none'"
                        [layout]="quickLink.layout"
                        [showSmallIcons]="false" />
                </div>
            }
        }
    </div>
    <div class="greyhounds-center">
        <ms-horses-base [sport]="sport" />
    </div>
</div>
